// extracted by mini-css-extract-plugin
module.exports = {"newInterviewBtnWrapper":"MyInterviewsTable_newInterviewBtnWrapper__g0TiA","detailsModalLink":"MyInterviewsTable_detailsModalLink__1Yngh"};